import React from 'react';
import {
    StepperContainer,
    StepContainer
} from './styles';
import TruckIcon from '~/assets/images/truck-black.svg';
import TruckMapIcon from '~/assets/images/truck-map.png';

const Stepper = ({ activeStep, steps }) => {

  function calculatePercetage(step, steps) {
    return (step) * 100 / steps;
  }

  return (
    <StepperContainer>
      {[...Array(steps)].map((_, index) => (
        <StepContainer
          key={index}
          step={activeStep}
          steps={steps}
          percentage={(calculatePercetage(activeStep, steps))}
          index={index}
        >
          <img
            className="truck"
            src={TruckMapIcon}
            alt="truck icon"
          />
        </StepContainer>
      ))}
    </StepperContainer>
  );
};

export default Stepper;
